




























































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Category from "@/store/entities/category";
import simplifyString from "simplify-string";
class CategoriesPageRequest extends PageRequest {
  keyword: string;
}

@Component({
  components: {},
})
export default class Categories extends AbpBase {
  //filters
  pagerequest: CategoriesPageRequest = new CategoriesPageRequest();
  category: Category = new Category();
  editCategory: Category = new Category();
  editIndex: number = -1;
  get list() {
    return this.$store.state.category.list;
  }
  get loading() {
    return this.$store.state.category.loading;
  }
  get pageSize() {
    return this.$store.state.category.pageSize;
  }
  get totalCount() {
    return this.$store.state.category.totalCount;
  }
  get currentPage() {
    return this.$store.state.category.currentPage;
  }
  @Watch("category.name")
  oncategoryNamechanged(val: string, oldVal: string) {
    if (val == undefined) {
      return false;
    }
    this.category.simpleCategoryName = simplifyString(val);
  }
  @Watch("editCategory.name")
  oncategoryNamechanged2(val: Category, oldVal: Category) {
    this.editCategory.simpleCategoryName = simplifyString(val);
  }
  async create() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store
          .dispatch({
            type: "category/create",
            data: this.category,
          })
          .then(() => {
            this.category = new Category();
            this.getpage();
          });
      }
    });
  }
  async save(index) {
    this.list[index].name = this.editCategory.name;
    this.list[index].simpleCategoryName = simplifyString(
      this.editCategory.name
    );
    this.list[index].description = this.editCategory.description;
    this.editIndex = -1;
    this.editCategory.id = this.list[index].id;
    await this.$store.dispatch({
      type: "category/update",
      data: this.editCategory,
    });
  }
  edit(row, index) {
    const categoryId = row.id;
    this.$router.push({ name: "category", params: { categoryId } });
    // let edit = new Category();
    // edit.name = row.name;
    // edit.simpleCategoryName = row.simpleCategoryName;
    // edit.description = row.description;
    // this.editCategory = edit;
    // this.editIndex = index;
  }
  async deleteCat(row, index) {
    await this.$store
      .dispatch({
        type: "category/delete",
        data: row,
      })
      .then(() => {
        this.getpage();
      });
  }
  async search() {
    this.$store.commit("category/setCurrentPage", 1);
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("category/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("category/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "category/getAll",
      data: this.pagerequest,
    });
  }
  rules = {
    name: [
      { required: true, message: this.L("PleasefillName"), trigger: "blur" },
    ],
  };
  columns = [
    {
      title: this.L("Name2"),
      slot: "name",
    },
    {
      title: this.L("SimpleCategoryName"),
      slot: "simpleCategoryName",
    },
    {
      title: this.L("Description"),
      slot: "description",
    },
    {
      title: this.L("Action"),
      slot: "action",
      width: 100,
    },
  ];
  async created() {
    this.getpage();
  }
}
